import { getApi } from '@BUP/services/Axios'

export const fetchAll = resultId => async () => {
  const client = await getApi('schools', { version: 4, authenticated: true })
  return client
    .get(`current-organization/results/${resultId}/recommendation`)
    .then(response => response.data)
}
